import { v4 } from 'uuid'

import { LocalFile } from '@types'

export function mapFileToLocalFile(file: File): LocalFile {
  return {
    id: v4(),
    name: file.name,
    type: file.type,
    data: file,
    url: URL.createObjectURL(file),
  }
}
